<script>
import CMSSinglePage from "@/views/components/cms/CMSSinglePage.vue";

export default {
  name: "Einarbeitung",
  components: {CMSSinglePage},
}
</script>

<template>
 <CMSSinglePage list-element="EinarbeitungList"></CMSSinglePage>
</template>

<style scoped>

</style>
